<template>
    <div class="legal tight">
        <loading v-if="!content"></loading>
        <div v-else>
          <h1 v-if="title">{{ title }}</h1>
          <div v-html="content"></div>
        </div>
    </div>
</template>


<script>
import api from 'js/api/resources'
import notify from 'js/components/notifications/notificationsMixin'

import Loading from 'js/components/elements/Loading.vue'


export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [ notify ],
    components: { Loading },
    data: function() {
        return {
            content: '',
        }
    },
    mounted: function() {
        this.request().then(res => { this.content = res.data })
        .catch(() => {
            this.$warn('Kan pagina niet vinden.')
            this.close()
        })
    },
    methods: {
        close: function() {
            this.$emit('close')
        },

        request: function() {
            if (this.type == 'privacy') {
                return api.getLegalPrivacy()
            }
          
            if (this.type == 'disclaimer') {
                return api.getLegalDisclaimer()
            }

            if (this.type == 'terms') {
                return api.getLegalTerms()
            }
        }
    },
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Legal.vue?10fb82b6